// A single soft, blurred leaf silhouette.
const Leaf = ({ size, top, left, color }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    style={{ position: 'absolute', top, left, opacity: 0.14, transform: 'rotate(-8deg)' }}
  >
    <path
      d="M50 5 C 80 15, 95 45, 50 95 C 5 45, 20 15, 50 5 Z"
      fill={color}
    />
    <path d="M50 10 L50 90" stroke={color} strokeOpacity="0.4" strokeWidth="2" />
  </svg>
)

// A large soft blurred color blob.
const Blob = ({ size, top, left, color }) => (
  <div
    style={{
      position: 'absolute',
      top,
      left,
      width: size,
      height: size,
      borderRadius: '9999px',
      background: color,
      filter: 'blur(80px)',
      opacity: 0.35
    }}
  />
)

// These used to drift and breathe via 8 separate Framer Motion animations,
// each with repeat: Infinity - meaning they never stopped for the entire
// lifetime of every page, on every visit. Under PageSpeed Insights' mobile
// CPU throttling this alone accounted for the vast majority of a ~29s main-
// thread CPU time reading on a page whose own JS only takes ~1.5s to
// evaluate - a pure decoration (aria-hidden, pointer-events-none, zero
// functional purpose) was the single biggest cost on the page. Rendered as
// static shapes now; no motion, no ongoing CPU cost.
const AmbientBackground = () => {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 overflow-hidden pointer-events-none"
      style={{ zIndex: 0 }}
    >
      {/* Soft ambient color blobs - fresh green, chicken gold, meat red */}
      <Blob size={480} top="-10%" left="-10%" color="#22c55e" />
      <Blob size={420} top="40%" left="70%" color="#f59e0b" />
      <Blob size={380} top="75%" left="10%" color="#ef4444" />

      {/* Leaf silhouettes - the signature touch */}
      <Leaf size={90} top="12%" left="18%" color="#16a34a" />
      <Leaf size={60} top="65%" left="80%" color="#d97706" />
      <Leaf size={70} top="30%" left="85%" color="#16a34a" />
      <Leaf size={50} top="80%" left="30%" color="#16a34a" />
      <Leaf size={65} top="5%" left="60%" color="#d97706" />
    </div>
  )
}

export default AmbientBackground
